import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UserService } from '@ark7/resources-common';

@Component({
    selector: 'a7-social-sign-in',
    templateUrl: './social-sign-in.component.html',
    styleUrls: ['./social-sign-in.component.scss'],
    standalone: false
})
export class SocialSignInComponent implements OnInit {
  @Input() mode: string = 'normal';
  @Input() action: string = 'Sign in';
  @Input() wordClasses = '';
  @Input() redirectTo: string;

  @Input()
  @HostBinding('class.blue-fb')
  blueFb = true;

  constructor(private userService: UserService) {}

  ngOnInit(): void {}

  signInGoogle() {
    this.userService.signInGoogle(this.redirectTo);
  }

  signInFacebook() {
    this.userService.signInFacebook(this.redirectTo);
  }

  signInApple() {
    this.userService.signInApple(this.redirectTo);
  }
}
